import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { obtenerCampus, otenerCategorias } from "../../helper";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import "dayjs/locale/es";

dayjs.extend(customParseFormat);

function FiltrosComponent({
  onChangeCampus,
  addChip,
  removeChipByType,
  buttonClicked,
  __nivel,
  __campus,
  __date,
}) {
  dayjs.locale("es");
  const [campus, setCampus] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [selectedCategoria, setselectedCategoria] = useState({});
  const [selectedValues, setSelectedValues] = useState({});
  const [selectedNivel, setNivel] = useState({});
  const [datosCargados, setDatosCargados] = useState(false);
  const [datosCargados2, setDatosCargados2] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  console.log(selectedNivel)
  const handleStartDateChange = (date) => {
    console.log("fecha inicio ----");
    console.log(date);
    setStartDate(date);
    if (endDate) {
      if (endDate.year() === date.year()) {
        if (endDate.month() === date.month()) {
          let fechaChip =
            "Del " +
            date.date() +
            " al " +
            endDate.date() +
            " de " +
            date.locale("es").format("MMMM");
          // addChip(fechaChip, "fecha");
          addChip(
            fechaChip,
            "fecha",
            null,
            null,
            date.format("YYYY/MM/DD") + "-" + endDate.format("YYYY/MM/DD")
          );
        } else {
          let fechaChip =
            "Del " +
            date.date() +
            " de " +
            endDate.locale("es").format("MMMM") +
            " al " +
            date.date() +
            " de " +
            date.locale("es").format("MMMM");
          addChip(
            fechaChip,
            "fecha",
            null,
            null,
            date.format("YYYY/MM/DD") + "-" + endDate.format("YYYY/MM/DD")
          );
        }
      } else {
        let fechaChip =
          "Del " +
          date.format("DD/MM/YYYY") +
          " al " +
          endDate.format("DD/MM/YYYY");
        addChip(
          fechaChip,
          "fecha",
          null,
          null,
          date.format("YYYY/MM/DD") + "-" + endDate.format("YYYY/MM/DD")
        );
      }
    }
  };

  const dateAwait = async (date, newChip) => {
    handleStartDateChange(date);
    handleEndDateChange(date, newChip);
  };

  const handleEndDateChange = (date, newChip = null) => {
    setEndDate(date);
    let __setarDate = null;
    if (!startDate) {
      __setarDate = date;
    } else {
      __setarDate = startDate;
      newChip = null;
    }
    console.log("newChip dentro de fecha fin---");
    console.log(newChip);
    if (__setarDate.year() === date.year()) {
      if (__setarDate.month() === date.month()) {
        let fechaChip =
          "Del " +
          __setarDate.date() +
          " al " +
          date.date() +
          " de " +
          date.locale("es").format("MMMM");
        // addChip(fechaChip, "fecha");
        addChip(
          fechaChip,
          "fecha",
          null,
          newChip,
          __setarDate.format("YYYY/MM/DD") + "-" + date.format("YYYY/MM/DD")
        );
      } else {
        let fechaChip =
          "Del " +
          __setarDate.date() +
          " de " +
          __setarDate.locale("es").format("MMMM") +
          " al " +
          date.date() +
          " de " +
          date.locale("es").format("MMMM");
        addChip(
          fechaChip,
          "fecha",
          null,
          newChip,
          __setarDate.format("YYYY/MM/DD") + "-" + date.format("YYYY/MM/DD")
        );
      }
    } else {
      let fechaChip =
        "Del " +
        __setarDate.format("DD/MM/YYYY") +
        " al " +
        date.format("DD/MM/YYYY");
      addChip(
        fechaChip,
        "fecha",
        null,
        newChip,
        __setarDate.format("YYYY/MM/DD") + "-" + date.format("YYYY/MM/DD")
      );
    }
  };


  ///Funcion que contrea el menu de Campus
  const handleChangeExpand = () => {
    setDatosCargados((prevState) => !prevState); // Alternar el estado de datosCargados
  };
  ///Funcion que contrea el menu de categorias
  const handleChangeExpand2 = () => {
    setDatosCargados2((prevState) => !prevState); // Alternar el estado de datosCargados
  };
  useEffect(() => TriggeredFunc(buttonClicked), [buttonClicked]);
  ///Funcion que se detona cuando en el padre para enviar la data del chip borrado
  const TriggeredFunc = (test) => {
    switch (test.tipo) {
      case "nivel":
        setDatosCargados(false);
        setNivel("");
        setCampus([]);
        setCategorias([]);
        break;
      case "campus":
        setSelectedValues("");
        break;
      case "fecha":
        setStartDate(null);
        setEndDate(null);
        break;
      case "categoria":
        setCategorias([]);
        break;

      default:
        break;
    }
  };
  const onPageLoad = async () => {
    const selectedNivel = "sede";
    setNivel(selectedNivel);
    setDatosCargados(true);
    await getCategorias(selectedNivel);
    await fetchData2(selectedNivel);
  };

  const handleChangeCategorias = (event) => {
    const selectCategories = event.target.value;
    setselectedCategoria(event.target.value);
    const selectedCategoria = categorias.find(
      (categoriaItem) => categoriaItem.id_categoria === selectCategories
    );
    console.log("categoria event.target.value---");
    console.log(selectedCategoria);

    if (selectedCategoria) {
      const categoriaName = selectedCategoria.titulo;
      addChip(categoriaName, "categoria");
    }
  };

  const fetchData2 = async (selectedNivel) => {
    try {
      let cd = await obtenerCampus(selectedNivel);
      setCampus(await obtenerCampus(selectedNivel));
      setDatosCargados(true);
      const __selectedValue = __campus;
      const selectedCampus = cd.find(
        (campusItem) => campusItem.name === __selectedValue
      );
      if (selectedCampus) {
        const campusName = selectedCampus.name;
        setSelectedValues(selectedCampus.sf_key);
        const selectedNivel = "sede";
        const newChip = [
          {
            titulo: selectedNivel,
            tipo: "nivel",
          },
          {
            titulo: campusName,
            tipo: "campus",
          },
        ];
        if (__date == null) {
          addChip("", "", "test", newChip);
        } else {
          const __Date = dayjs(__date);
          await dateAwait(__Date, newChip);
        }
      } else {
        const selectedNivel = __nivel;
        const newChip = [
          {
            titulo: selectedNivel,
            tipo: "nivel",
          },
        ];
        if (__date == null) {
          addChip("", "", "test", newChip);
        } else {
          const __Date = dayjs(__date);
          await dateAwait(__Date, newChip);
        }
      }
    } catch (error) {
      console.error("Error fetching campuses:", error);
    }
  };

  const getCategorias = async (selectedNivel) => {
    let __selectedNivel;
    if (selectedNivel === "profesional" || selectedNivel === "Profesional") {
      __selectedNivel = "05";
    } else {
      __selectedNivel = "03";
    }
    let categorias = await otenerCategorias(__selectedNivel);
    setCategorias(categorias);
  };

  useEffect(() => {
    if (__nivel) {
      if (__campus) {
        onPageLoad();
      }
    }
    // eslint-disable-next-line no-use-before-define, react-hooks/exhaustive-deps
  }, [__nivel, __campus]);

  const handleChangeCampus = (event) => {
    const selectedValue = event.target.value;
    setSelectedValues(selectedValue);
    const selectedCampus = campus.find(
      (campusItem) => campusItem.sf_key === selectedValue
    );
    if (selectedCampus) {
      const campusName = selectedCampus.name;
      addChip(campusName, "campus");
    }
  };


  const isSmallScreen = useMediaQuery("(max-width:900px)");

  return (
    <div>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid
              container
              direction={isSmallScreen ? "column" : "row"}
              spacing={2}
            >
              <Grid item xs={12} sm={6}>
                <DatePicker
                  defaultValue={null}
                  value={startDate}
                  onChange={handleStartDateChange}
                  dateFormat="YYYY-MM-DD"
                  label="Del"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DatePicker
                  defaultValue={null}
                  value={endDate}
                  onChange={handleEndDateChange}
                  dateFormat="YYYY-MM-DD"
                  label="Al"
                  minDate={startDate}
                  fullWidth
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
        </Grid>

      </Grid>

      <Accordion
        expanded={datosCargados} // Utilizar datosCargados como valor de expanded
        onChange={handleChangeExpand}
      >
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          aria-controls={`panel2-content`}
          id={`panel2-header`}
        >
          <Typography
            component="div"
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            <FormatListBulletedIcon />
            Campus
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <RadioGroup
            value={selectedValues}
            onChange={(event) => handleChangeCampus(event, event.value)}
          >
            {campus.map((campusItem, idx) => (
              <FormControlLabel
                key={idx}
                value={campusItem.sf_key}
                control={<Radio />}
                label={campusItem.name}
              />
            ))}
          </RadioGroup>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={datosCargados2} // Utilizar datosCargados como valor de expanded
        onChange={handleChangeExpand2}
      >
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          aria-controls={`panel3-content`}
          id={`panel3-header`}
        >
          <Typography
            component="div"
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            <FormatListBulletedIcon />
            Categoria
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <RadioGroup
            value={selectedCategoria}
            onChange={(event) => handleChangeCategorias(event, event.value)}
          >
            {categorias.map((categoria, idx) => (
              <FormControlLabel
                key={idx}
                value={categoria.id_categoria}
                control={<Radio />}
                label={categoria.titulo}
              />
            ))}
          </RadioGroup>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default FiltrosComponent;
